const translations = {
    label: 'Product Usage Report (Created on {{createdOn}} for {{contact}} at {{siteName}})',
    notSet: 'Not set',
    tbd: 'TBD'
};

export default translations;
